module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_is-object.js
// module id = 3
// module chunks = 0 1 2 3 4 5 6 7 8